import { connect } from 'react-redux';
import {
    setAlignment,
    setFont,
    setText,
    toggleBold,
    toggleItalic,
} from '../actions/actionCreators/textEditor';
import TextEditor from '../components/TextEditor';
import { openColorPicker } from '../actions/actionCreators/configurator';

function mapStateToProps(state) {
    return {
        alignment: state.textEditor.alignment,
        font: state.textEditor.font,
        text: state.textEditor.text,
        bold: state.textEditor.bold,
        italic: state.textEditor.italic,
        color: state.textEditor.color,
        placeholder: state.app.texts['text.editor.placeholder'],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setAlignment: alignment => dispatch(setAlignment(alignment)),
        setFont: font => dispatch(setFont(font)),
        setText: text => dispatch(setText(text)),
        toggleBold: () => dispatch(toggleBold()),
        toggleItalic: () => dispatch(toggleItalic()),
        openColorPicker: () => dispatch(openColorPicker()),
    };
}

const TextEditorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TextEditor);

export default TextEditorContainer;
